import { Box, Typography } from "@mui/material";
import React from "react";
import { useCreateElementContext } from "../Context/CreateElementContext";
import FormComponent from "../../../Common/FormComponent/FormComponent";
import { ErrorLabel } from "../../ElementForm";

const containerProps = {
  sx: {
    display: "flex",
    gap: 2,
    "& > *": {
      flex: 1,
    },
  },
};
export const config = [
  {
    id: "title",
    label: "Series title",
    containerProps,
    required: true,
    props: {
      placeholder: "Add series title",
    },
  },
  {
    id: "description",
    label: "Series description",
    containerProps,
    required: true,
    props: {
      placeholder: "add series description",
    },
  },
];

const SeriesContent = ({}) => {
  const { form, options } = useCreateElementContext();

  const getLanguages = ({ lang_code }) =>
    options?.languages?.find((lang) => lang.value === lang_code)?.label;
  return (
    <Box my={2}>
      {form.values.content.map((item, index) => (
        <Box
          key={index}
          borderBottom={"4px solid #F5F5F5"}
          py={3}
          display={"flex"}
          flex={1}
          flexDirection={"column"}
          gap={2}
        >
          <Typography
            variant="h6"
            color="GrayText"
            sx={{ textTransform: "uppercase", letterSpacing: 3 }}
          >
            CONTENT: {getLanguages({ lang_code: item.lang_code })}{" "}
            {index === 0 && "(DEFAULT)"}
          </Typography>

          <Box
            display={"flex"}
            gap={2}
            mt={2}
            flexDirection={"column"}
            flex={1}
          >
            {config
              .map((item) => ({
                ...item,
                id: `content.${index}.${item.id}`,
              }))
              .map((item) => (
                <Box>
                  <FormComponent
                    config={item}
                    form={form}
                    key={item.id}
                    otherOptions={options[item?.props?.optionsKey ?? item.id]}
                  />
                  <ErrorLabel label={form.errors[item.id]} />
                </Box>
              ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default SeriesContent;
